import { Packer } from "docx"
import { saveAs } from "file-saver"
import { FileText } from "lucide-react"

import { markdownToDocx } from "@lib/file"

import { Button } from "@ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"

interface DownloadAsDocxButtonProps {
    content: string | object
    filename?: string
    variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
    size?: "default" | "sm" | "lg" | "icon" | "xs"
    hideText?: boolean
}
export function DownloadAsDocxButton({ content, filename, variant = "default", size = "default", hideText = false }: Readonly<DownloadAsDocxButtonProps>) {
    const handleDonwload = async () => {
        const value = typeof content === "object" ? JSON.stringify(content, null, 2) : String(content)

        const doc = markdownToDocx(value)
        const blob = await Packer.toBlob(doc)
        saveAs(blob, filename ? `${filename}.docx` : `vertesia-document-${new Date().toISOString()}.docx`)
    }

    if (hideText) {
        return (
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button size={size} variant={variant} onClick={handleDonwload}>
                            <FileText />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>Download as DOCX</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        )
    }

    return (
        <Button size="sm" variant="default" onClick={handleDonwload}>
            <FileText className="size-4 mr-1" />
            Export as Docx
        </Button>
    )
}
